"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var constants_1 = require("../../../constants");
var core_2 = require("@ngx-translate/core");
var lodash_1 = __importDefault(require("lodash"));
var authorization_service_1 = require("../../../services/authorization.service");
var DashboardAgendaComponent = /** @class */ (function () {
    //public activityResult: string;
    function DashboardAgendaComponent(tService, authorizationService, dealSheetService) {
        var _this = this;
        this.tService = tService;
        this.authorizationService = authorizationService;
        this.dealSheetService = dealSheetService;
        this.activityResultTypeDescriptors = constants_1.ActivityResultTypeDescriptors;
        this.activityStatusTypes = constants_1.ActivityStatusTypes;
        this.dealSheetClosed = new core_1.EventEmitter();
        this.activityIconClasses = constants_1.ActivityIconClasses;
        this.dealSheetClose = function (opId) {
            _this.dealSheetClosed.emit({ opId: opId });
        };
    }
    DashboardAgendaComponent.prototype.ngOnInit = function () {
    };
    DashboardAgendaComponent.prototype.openDealSheet = function (entityId) {
        var isEuroLite = this.authorizationService.isEuroLite();
        if (!isEuroLite)
            this.dealSheetService.openDealSheetModal(entityId, null, this.dealSheetClose);
        else
            this.dealSheetService.openDealSheetLiteModal(null, entityId);
    };
    DashboardAgendaComponent.prototype.getResult = function (item) {
        if (item.activityResultID) {
            var activityResultType = lodash_1.default.find(this.activityResultTypeDescriptors, function (o) {
                return o.activityResultID === item.activityResultID;
            });
            return this.tService.instant(activityResultType.activityResultNameTranslateKey);
        }
        else if (item.activityStatusID) {
            var activityStatusTypeName = (lodash_1.default.invert(this.activityStatusTypes))[item.activityStatusID];
            return this.tService.instant('ACTIVITY.' + activityStatusTypeName.toUpperCase());
        }
    };
    return DashboardAgendaComponent;
}());
exports.DashboardAgendaComponent = DashboardAgendaComponent;
